 
import {
  ATTENDANCE_REQUEST,
  ATTENDANCE_SUCCESS,
  ATTENDANCE_FAIL,
  GET_LOAD_BA_ATTENDANCE_SUCCESS,
  GET_LOAD_BA_ATTENDANCE_REQUEST,
  GET_LOAD_BA_ATTENDANCE_FAIL,
  GET_ABSENT_EMPLOYEES_FAIL,
  GET_ABSENT_EMPLOYEES_SUCCESS,
  GET_ABSENT_EMPLOYEES_REQUEST
} from "../constants/AttendanceContant";

const initialState = {
  requestBody: null,
  responseBody: [],
  divisionData: [],
  WeekAttendance: [],
  traineeTypes: [],
  traineeDivision: [],
  allAttendance: [],
  allAttendance1: [],
  cdplcData: [],
  loadBaAttendance: [],  
  otData: null,
  error: null,
  msg: null,
  loading: false,
  absentEmployees: [],
  absentLoading: false,
  absentError: null,
};

export const GetAttendanceCard = (state = initialState, action) => {
  switch (action.type) {
    case ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
        msg: null,
      };
    case ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        responseBody: action.payload.responseBody || state.responseBody,
        divisionData: action.payload.divisionData || state.divisionData,
        WeekAttendance: action.payload.WeekAttendance || state.WeekAttendance,
        traineeTypes: action.payload.traineeTypes || state.traineeTypes,
        traineeDivision: action.payload.traineeDivision || state.traineeDivision,
        allAttendance: action.payload.allAttendance || state.allAttendance,
        allAttendance1: action.payload.allAttendance1 || state.allAttendance1,
        cdplcData: action.payload.cdplcData || state.cdplcData,
         otData: action.payload.otData || state.otData,
        msg: null,
      };
    case ATTENDANCE_FAIL:
      return {
        ...state,
        loading: false,
        msg: action.payload.msg,
        responseBody: [],
      };
    
    case GET_LOAD_BA_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
        msg: null,
      };
    case GET_LOAD_BA_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        loadBaAttendance: action.payload, // Directly set the array, not action.payload.loadBaAttendance
        msg: null,
      };
    case GET_LOAD_BA_ATTENDANCE_FAIL:
      return {
        ...state,
        loading: false,
        msg: action.payload.msg,
        loadBaAttendance: [],
      };
      case GET_ABSENT_EMPLOYEES_REQUEST:
  return {
    ...state,
    absentLoading: true,
    absentError: null,
  };
case GET_ABSENT_EMPLOYEES_SUCCESS:
  return {
    ...state,
    absentEmployees: action.payload,
    absentLoading: false,
  };
case GET_ABSENT_EMPLOYEES_FAIL:
  return {
    ...state,
    absentLoading: false,
    absentError: action.payload.msg,
  };
    
    default:
      return state;
  }
};